import React, { useState, useEffect } from 'react';
import { crmClient } from '../lib/crmRpc';
import { InstallPwaButton } from './InstallPwaButton';

export default function CrmLogin() {
  const [gatewaySlug, setGatewaySlug] = useState('');
  const [gatewayError, setGatewayError] = useState('');

  useEffect(() => {
    let link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }
    link.crossOrigin = 'anonymous';
    link.href = `/api/manifest.json?start_url=${encodeURIComponent(window.location.pathname + window.location.search)}&origin=${encodeURIComponent(window.location.origin)}&v=${Date.now()}`;
  }, []);

  const handleLogin = async () => {
    if (gatewaySlug.trim()) {
       setGatewayError('');
       try {
          const res = await crmClient.api.v1['crm-dashboard'][':slug'].live.$get({ param: { slug: gatewaySlug.trim() } });
          if (res.status === 404) {
             setGatewayError('There is no dashboard with that key.');
             return;
          }
          const basePath = typeof window !== 'undefined' && window.location.hostname === 'crm.dark.tel' ? '/' : '/services/crm/';
          window.location.href = `${basePath}${gatewaySlug.trim()}`;
       } catch(err) { setGatewayError('Connection Failed'); }
    }
  };

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
       <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '2.5rem', width: '100%', maxWidth: '400px', textAlign: 'center', boxShadow: '0 10px 25px rgba(0,0,0,0.5)', backdropFilter: 'blur(10px)' }}>
          <h2 style={{ color: 'white', marginTop: 0, paddingBottom: '1.5rem', borderBottom: '1px solid rgba(255,255,255,0.1)', marginBottom: '1.5rem', fontSize: '1.5rem', letterSpacing: '-0.5px' }}>CRM Dashboard</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>Please enter your Dashboard Key.</p>
          <input 
             type="text" 
             placeholder="e.g. 96605df9267c..."
             value={gatewaySlug}
             onChange={(e) => setGatewaySlug(e.target.value)}
             style={{ width: '100%', padding: '0.75rem', background: 'rgba(0,0,0,0.4)', border: '1px solid var(--border-light)', color: 'white', borderRadius: '4px', marginBottom: '1rem', boxSizing: 'border-box' }}
             onKeyDown={(e) => { 
                if (e.key === 'Enter') handleLogin();
             }}
          />
          {gatewayError && <div style={{ color: '#ef4444', fontSize: '0.85rem', marginBottom: '1rem' }}>{gatewayError}</div>}
          <button 
             onClick={handleLogin}
             style={{ width: '100%', padding: '0.75rem', background: 'var(--primary)', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600, transition: 'all 0.2s' }}
             onMouseOver={(e) => e.currentTarget.style.opacity = '0.9'}
             onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
          >
             Access Dashboard
          </button>
          <div style={{ marginTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '1.5rem' }}>
             <InstallPwaButton isLight={false} />
          </div>
       </div>
    </div>
  );
}
